import { IOption } from '../interfaces/common/i-option';

/**
 * The three logical environments a runtime-managed feature flag can be scoped
 * to. The many runtime identifiers (see `EnvIdentifier`) collapse into these via
 * `FeatureFlagHelper.mapRuntimeToEnvironment`.
 */
export enum FeatureFlagEnvironment {
  Dev = 'dev',
  Staging = 'staging',
  Production = 'production',
}

/** the targeting dimensions a flag's criteria can restrict on (AND-composed) */
export enum FeatureFlagCriterionType {
  Role = 'role',
  User = 'user',
  Team = 'team',
  Machine = 'machine',
}

/** whether a Machine criterion targets every machine or an explicit list */
export enum FeatureFlagMachineMode {
  All = 'all',
  List = 'list',
}

/** mutation kinds recorded in the audit trail */
export enum FeatureFlagAuditAction {
  Create = 'create',
  Update = 'update',
  Toggle = 'toggle',
  Duplicate = 'duplicate',
  Delete = 'delete',
}

export const FEATURE_FLAG_ENVIRONMENT_OPTIONS: IOption[] = [
  { label: 'Dev', value: FeatureFlagEnvironment.Dev },
  { label: 'Staging', value: FeatureFlagEnvironment.Staging },
  { label: 'Production', value: FeatureFlagEnvironment.Production },
];
